export const PASSWORD_STRENGTH_PASSWORD_CHANGED = 'PASSWORD_STRENGTH_PASSWORD_CHANGED';
export const PASSWORD_STRENGTH_PASSWROD_CONFIRMATION_CHANGED =
  'PASSWORD_STRENGTH_PASSWROD_CONFIRMATION_CHANGED';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/PasswordStrength/PasswordStrengthConstants.js